import { BaseNomenclature } from "./baseNomenclature.model";

export class BudgetCode extends BaseNomenclature {


    constructor() {
    super()
    this.collection_name="budget_code";  
    }
}